const DEVICES_API_URL = "http://127.0.0.1:8000/api/devices/devices/?format=json";
const HOSPITALS_API_URL = "http://127.0.0.1:8000/api/hospitals/?format=json";

async function parseJsonSafe(response) {
  const text = await response.text();
  try {
    return text ? JSON.parse(text) : {};
  } catch {
    return { detail: text || "Invalid server response" };
  }
}

export async function createDevice(payload) {
  const response = await fetch(DEVICES_API_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  const data = await parseJsonSafe(response);

  if (!response.ok) {
    throw data;
  }

  return data;
}

export async function getHospitals() {
  const response = await fetch(HOSPITALS_API_URL, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });

  const data = await parseJsonSafe(response);

  if (!response.ok) {
    throw data;
  }

  return data;
}